import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { t } from 'i18next';
import { 
  REMOVE_ROWS_CONFIRMATION_MODAL_I18N_KEYS as MY_I18N_KEYS, 
  REMOVE_ROWS_CONFIRMATION_MODAL_I18N_PREFIX as MY_I18N_PREFIX 
 } from '../constants/i18n/RemoveRowsConfirmationModali18nConstants';
import { LOCAL_STORAGE_KEY_FOR_DO_NOT_SHOW_REMOVE_ROWS_CONFIRMATION } from '../../components/constants/constants';

class RemoveRowsConfirmationModal extends Component {
  static propTypes = {
    show: PropTypes.bool.isRequired,
    handleRemoveRowsWithErrorsCancellation: PropTypes.func.isRequired,
    handleRemoveRowsWithErrorsConfirmation: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      hasCheckedDoNotShowRemoveRowsConfirmation: false,
    };
  }

  getI18nText(textKey) {
    return t(MY_I18N_PREFIX + "." + textKey);
  }

  handleCheckboxChange = (event) => {
    this.setState({ hasCheckedDoNotShowRemoveRowsConfirmation: event.target.checked });
  };

  handleContinueButton = () => {
    const { hasCheckedDoNotShowRemoveRowsConfirmation } = this.state;

    if (hasCheckedDoNotShowRemoveRowsConfirmation) {
      localStorage.setItem(LOCAL_STORAGE_KEY_FOR_DO_NOT_SHOW_REMOVE_ROWS_CONFIRMATION, 'true');
    }

    this.props.handleRemoveRowsWithErrorsConfirmation();
  };

  render() {
    const { show, handleRemoveRowsWithErrorsCancellation} = this.props;

    return (
      <div className={`modal create-upload-data-topic-modal confirmation-modal ${show ? 'modal-show' : 'modal-hide'}`}>
        <div className="confirmation-modal-dialog">
          <div className="confirmation-modal-content">
            <div className="confirmation-modal-header">
              <span className="confirmation-modal-title">
                {this.getI18nText(MY_I18N_KEYS.modal_title)}
              </span>
            </div>
            <div className="confirmation-modal-body">
              <p>
                {this.getI18nText(MY_I18N_KEYS.paragraph_1)}
              </p>
              <p>
                {this.getI18nText(MY_I18N_KEYS.paragraph_2)}
              </p>
              <div className="checkbox-container">
                <input 
                  id="do-not-show-again-checkbox"
                  className="styled-checkbox"
                  type="checkbox" 
                  checked={this.state.hasCheckedDoNotShowRemoveRowsConfirmation}
                  onChange={this.handleCheckboxChange}
                />
                <label
                  htmlFor="do-not-show-again-checkbox" 
                  style={{ cursor: "pointer" }}
                >
                  {this.getI18nText(MY_I18N_KEYS.do_not_show_this_message_again)}
                </label>
              </div>
            </div>
            <div className="confirmation-modal-footer">
              <button
                className='btn variable-width-btn'
                onClick={handleRemoveRowsWithErrorsCancellation}
              >
                {this.getI18nText(MY_I18N_KEYS.cancel_button_text)}
              </button>
              <button
                className='btn btn-submit variable-width-btn'
                onClick={this.handleContinueButton}
              >
                {this.getI18nText(MY_I18N_KEYS.continue_button_text)}
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default RemoveRowsConfirmationModal;



// WEBPACK FOOTER //
// ./src/features/topics/components/file-upload/RemoveRowsConfirmationModal.js